import PropTypes from 'prop-types';
import React from 'react';
import { SubmissionError } from 'redux-form';
import Layout from '../../../components/Layout';
import Profile from './Profile';
import ProfileForm from './ProfileForm';
import PasswordForm from './PasswordForm';
import diff from 'object-diff';


class ProfileLayout extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
  }
  componentWillMount() {
    const profile = JSON.parse(sessionStorage.getItem('auth'));
    if (this.props.needFetch) {
      this.props.requestProfile(profile.profile.user.id);
    }
  }
  handleSubmit(values) {
    if (values.password !== values.password2) {
      throw new SubmissionError({
        password2: 'Passwords do not match',
        _error: 'Password fields do not match',
      });
    }
    return this.props.setPassword(this.props.profile.user.id, values);
  }
  handleEdit(values) {
    const changedValues = diff(this.props.profile, values);
    return this.props.editProfile(this.props.profile.user.id, changedValues);
  }

  render() {
    if (this.props.isFetching || this.props.needFetch) {
      return (
        <Layout>
          <div className="planner col-sm-12">
            <p className="text-center">
              <i className="fa fa-spinner fa-spin fa-3x fa-fw" />
              <span className="sr-only">Loading...</span>
            </p>
          </div>
        </Layout>
      );
    }
    if (this.props.action === 'password') {
      return (
        <Layout>
          <div className="container">
            <div className="row">
              <div className="col-sm-12 planner">
                <PasswordForm
                  profile={this.props.profile}
                  onSubmit={this.handleSubmit}
                  onClose={this.props.gotoProfile}
                />
              </div>
            </div>
          </div>
        </Layout>
      );
    }
    if (this.props.action === 'edit') {
      return (
        <Layout>
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-12  planner">
                <ProfileForm
                  initialValues={this.props.profile}
                  onSubmit={this.handleEdit}
                  onClose={this.props.gotoProfile}
                />
              </div>
            </div>
          </div>
        </Layout>
      );
    }

    return (
      <Layout>
        <div className="container-fluid">
          <div className="row">
            <div className="planner col-sm-12">
              <Profile
                profile={this.props.profile}
                gotoProfileEdit={this.props.gotoProfileEdit}
                gotoProfilePassword={this.props.gotoProfilePassword}
                editProfileImage={this.props.editProfileImage}
              />
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

ProfileLayout.propTypes = {
  profile: PropTypes.shape({
    user: PropTypes.shape({
      id: PropTypes.number.isRequired,
      first_name: PropTypes.string.isRequired,
      last_name: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
    }),
    mobile: PropTypes.string,
    office: PropTypes.string,
    title: PropTypes.string,
    custom_image: PropTypes.string,
    image: PropTypes.string,
  }).isRequired,
  action: PropTypes.string.isRequired,
  needFetch: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  requestProfile: PropTypes.func.isRequired,
  setPassword: PropTypes.func.isRequired,
  editProfile: PropTypes.func.isRequired,
  gotoProfile: PropTypes.func.isRequired,
};
ProfileLayout.defaultProps = {
  profile: {
    id: null,
  },
};

export default ProfileLayout;



// WEBPACK FOOTER //
// src/routes/profile/components/ProfileLayout.js